import React from 'react';
import {
  ActivateProductMDSPage,
  SignupAndActivateProductMDSPage,
  ActivateProductThankYouPage,
} from '@front-activerse/modules';
import { Route } from '../Routing/types';
import { PATH_ACTIVATE, PATH_SIGNUP_AND_ACTIVATE, PATH_THANKYOU } from './paths';

const routes: Route[] = [
  {
    path: PATH_ACTIVATE,
    element: <ActivateProductMDSPage />,
    private: true,
    title: 'route-title/default',
  },
  {
    path: PATH_SIGNUP_AND_ACTIVATE,
    element: (
      <SignupAndActivateProductMDSPage
        pathActiveProduct={PATH_ACTIVATE}
        displayFacebookButton={false}
      />
    ),
    private: false,
    title: 'route-title/default',
  },
  {
    path: PATH_THANKYOU,
    element: <ActivateProductThankYouPage />,
    private: false,
    title: 'route-title/default',
  },
];

export default routes;
